<template>
    <div>
        <el-input
            :placeholder="placeholder"
            :disabled="disabled"
            :size="size"
            :readonly="isReadonly"
            style="line-hight: 40px"
            v-model="name"
            class="input-with-select"
            width="60%"
        >
            <el-button slot="append" :disabled="disabled" @click="showSelectDialog" icon="el-icon-notebook-2"></el-button>
        </el-input>
        <el-dialog title="文本字段" :close-on-click-modal="false" :append-to-body="true" :visible.sync="visible" width="400px">
            <div v-for="(item,key) in valueList" style="margin-bottom: 10px;" :key='key'>
                <el-input size="small" :disabled="feild.key" v-model="item.key" placeholder="请输入名称" style="width: 160px"></el-input> : <el-input :disabled="feild.value" size="small" v-model="item.value" placeholder="请输入字段" style="width: 160px"></el-input>
                <el-button :disabled="feild.btn" type="text" style="margin-left: 10px;" size="small" @click="pushOne" v-if="key == 0">添加</el-button>
                <el-button :disabled="feild.btn" type="text" style="color: #F56C6C;margin-left: 10px;" size="small" @click="deleteOne(item.key)" v-if="key != 0">删除</el-button>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogClose()">关闭</el-button>
                <el-button type="primary" @click="doSubmit()">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    props:{
        placeholder:{
            type: String,
            default: '请选择'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        feild: {
            type: Object,
            default: () => {
                return {key: false,value: false,btn: false};
            }
        },
        size: {
            type: String,
            default: () => {
                return 'default';
            }
        },
        isReadonly: {
            type: Boolean,
            default: true
        },
        value: {
            type: String,
            default: () => {
                return '';
            }
        }
    },
    data() {
        return {
            visible: false,
            name: '',
            valueList: [{key:'',value:''}],
        }
    },
    watch:{
        value(val) {
            console.log(val)
            if(val == ''){
                this.name=''
                return
            }
            // let array = val.replace(/\\&quot;/g, '\\"');
            if(typeof val === 'string' && /&quot;/.test(val)){
                let array = val.replace(/&quot;/g, '"');
                array = JSON.parse(array)
                console.log(array)
                // array = JSON.parse(array)
                console.log(array)
                if(array.length > 0){
                    this.name = array
                        .map((item) => {
                            return item.key;
                        })
                        .join(',');
                }else{
                    this.name = ''
                }
            }else{
                console.log(val)
                let array = JSON.parse(val)
                if(array.length > 0){
                    this.name = array
                        .map((item) => {
                            return item.key;
                        })
                        .join(',');
                }else{
                    this.name = ''
                }
            }
        }
    },
    methods: {
        showSelectDialog() {
            this.visible = true;
            if(typeof this.value === 'string' && /&quot;/.test(this.value)){
                let array = this.value.replace(/&quot;/g, '"');
                array = JSON.parse(array)
                // array = JSON.parse(array)
                if(array.length > 0){
                    this.valueList = array
                }
            }else{
                let valueList1 = JSON.parse(this.value)
                if(valueList1.length > 0){
                    this.valueList = valueList1
                }
            }
            console.log(this.valueList)
        },
        pushOne(){
            this.valueList.push({
                key: '',
                value: ''
            })
        },
        dialogClose(){
            this.visible = false;
            this.valueList = [{key:'',value:''}];
            console.log(this.name)
        },
        doSubmit(){
            this.name = this.valueList
                .map((item) => {
                    return item.key;
                })
                .join(',');
            console.log(this.name)
            this.$emit('getValue', JSON.stringify(this.valueList))
            this.dialogClose()
        },
        deleteOne(key){
            this.valueList = this.valueList.filter(item => item.key !== key)
        }
    },
}
</script>
<style lang="scss" scoped>
    
</style>